<template>
  <div>
    <LoadingSpinner :loading="isLoading" :text="$lang.sending_data" />
    <OptionForm
      v-if="!isLoading"
      mode="add"
      :item="item"
      @submit="save"
      @cancel="cancel"
      @responseCode="getResponseCode"
    />
  </div>
</template>

<script>
import OptionForm from "./../from/optionFrom";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "add-question-option",
  components: {
    OptionForm,
    LoadingSpinner,
  },
  inject: ["optionRepository", "attachmentRepository"],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
      resourceId: null,
      responseCode: [],
    };
  },
  methods: {
    pathOr,
    generateApiUrl,
    cancel() {
      this.$emit("cancel");
    },
    getResponseCode(code) {
      this.responseCode = code;
    },
    async finalSave() {
      try {
        if (!this.responseCode.length) return;
        let payload = {
          data: [],
        };
        for (const item of this.responseCode) {
          payload.data.push({
            code: pathOr(null, ["code"], item),
            unlimited: true,
            attachment_type_id: 28,
            attachment_type_name: "attachment_type_question_option",
          });
        }
        const url = generateApiUrl(
          ["resources", "resource_key_attachmentTemp"],
          ["option", this.resourceId]
        );
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.cancel();
        this.$emit("getItems");
      }
    },
    async save(payload) {
      if (payload.is_image && !this.responseCode.length) {
        return this.$notify.error("حداقل یک فایل را انتخاب کنید");
      }

      try {
        this.isLoading = true;
        const response = await this.optionRepository.create(payload);
        this.resourceId = pathOr(null, ["data", "data", "id"], response);
        if (this.resourceId) {
          await this.finalSave();
          this.$emit("getId", this.resourceId);
        }
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
